/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const DEFAULT_APP_CONFIG = {
    db: {
        boilerplate: {
            name: "boilerplate.realm",
        },
    },
    servers: {
        graphql: [
            {
                name: "api-gateway",
                url: "https://countries.trevorblades.com",
            },
            {
                name: "graphql-gateway",
                // url: "https://bl-epcc.gov.vu/vanuatu/sby/gql/",
                // url: "https://klefki-vanuatu-pg.vlinderserver.online/vanuatu/gql/",
                // url: 'https://integ-kelfki.vlinderserver.online/vanuatu/gql/',
                //url: 'https://dev-kelfki-qc.vlinderserver.online/vanuatu/gql/',
                url: "https://ramesh.vlinderserver.online/vanuatu/gql/",
                // url: 'http://localhost:4830/',
            },
        ],
        rest: {
            dummyRestServer: {
                baseURL: "http://10.0.1.13:8000",
            },
        },
        services: {
            // baseUrl: "https://bl-epcc.gov.vu/vanuatu/tom/rest/auth/basic",
            baseUrl: "https://ramesh.vlinderserver.online/vanuatu/auth/basic",
            // baseUrl: 'https://klefki-vanuatu-pg.vlinderserver.online/vanuatu/auth/basic',
            // baseUrl: 'https://integ-kelfki.vlinderserver.online/vanuatu/auth/basic',
            //baseUrl:"https://dev-kelfki-qc.vlinderserver.online/vanuatu/auth/basic",
            // baseUrl: 'http://localhost:3902/auth/basic'
        },
    },
};
